import React from 'react';

import Link from '@atlaskit/link';

export default function Visited(): React.JSX.Element {
	return <Link href="/components/link/examples">Default link</Link>;
}
